import { Translatable } from "@icc/shared/helpers";
import { RollerGuideOverlaySnapPlate, IccRollerGuideOverlaySnapPlate } from './guide-overlay-snap-plate';

export class RollerGuideSpacerStrip {
    id: number;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do indeksu */
    indexNo: string;
    @Translatable({ model: 'Profiles' })
    name: string;
    width: number;
    img: null | string;
    order?: number;
    default?: boolean;
    length?: number | null;
    colorGroupSetId: number | null;
    printCode: string;
    /** Waga */
    weight?: number;
    /** Waga stała */
    weightConst?: number;

    lengthAdjustment?: number;

    guideIds?: number[];

    /** Funkcja prowadnicy, dla której listwa dystansowa jest dostępna */
    availableForGuideFunction?: 'any' | 'single' | 'double';

    /** Płytka zatrzaskowa powiązana z listwą dystansową */
    snapPlate?: RollerGuideOverlaySnapPlate | null;
}

export interface IccRollerGuideSpacerStrip {
    id: number;
    extId: string;
    indexNo: string;
    name: string;
    width: number;
    img: null | string;
    order?: number;
    shutterTypes: number[];
    colorGroupSetId: number;
    printCode: string;
    /** Waga */
    weight?: number;
    /** Waga stała */
    weightConst?: number;
    guideIds?: number[];

    lengthAdjustment?: number;

    /** Funkcja prowadnicy, dla której listwa dystansowa jest dostępna */
    availableForGuideFunction?: 'any' | 'single' | 'double';

    /** Płytka zatrzaskowa powiązana z listwą dystansową */
    snapPlate?: IccRollerGuideOverlaySnapPlate | null;
}
